export default __webpack_public_path__ + "static/media/0xb35fcbcf1fd489fce02ee146599e893fdcdc60e6.6c8bedfd.webp";